'use strict';

import React from 'react';
import flux from 'utils/flux';
import trunc from 'lodash/string/trunc';
import BasketDropdown from 'components/basket/basketDropdown';
import AltContainer from 'alt-container';
import Immutable from 'immutable';
import { Navigation } from 'react-router';
import onclickoutside from 'react-onclickoutside';
import classnames from 'classnames';

var MediaListingItemInfo = React.createClass({

    displayName: 'MediaListingItemInfo',

    mixins: [
        onclickoutside,
        Navigation
    ],

    propTypes: {
        media: React.PropTypes.object
    },

    shouldComponentUpdate( nextProps ) {
        return ( Immutable.is(nextProps.item, this.props.item) === false );
    },

    handleClickOutside() {
        if (this.props.item.get('_basket')) {
            flux.getActions('media').toggleBasket( this.props.item.get('id') );
        }
    },

    toggleCheck(e) {
        e.preventDefault();
        flux.getActions('media').toggleItemSelection( this.props.item.get('id') );
    },

    toggleBasket(e) {
        e.preventDefault();
        flux.getActions('media').toggleBasket( this.props.item.get('id') );
    },

    generateQuickDownload(e) {
        e.preventDefault();
        flux.getStore('basket').createBasket([{id: this.props.item.get('id')}]).then(() => {
            setTimeout(() => {
                var activeBasketId = flux.getStore('basket').getState().activeBasketId;
                this.transitionTo( 'singleBasket', { id: activeBasketId });
            }, 20);
        });
    },

    generateInstantDownload(e) {
        e.preventDefault();
        flux.getActions('modals').openInstantDownloadModal(this.props.item);
    },

    renderBasket() {
        var mediaId   = this.props.item.get('id');
        var mediaName = this.props.item.get('name') || this.props.item.get('title');

        if (this.props.item.get('_basket')) {
            return (
                <AltContainer
                    stores={{basketStore: flux.getStore('basket')}}
                    transform={({ basketStore }) => {
                        var baskets = basketStore.baskets;
                        return {baskets};
                    }}>
                    <BasketDropdown mediaId={mediaId} mediaName={mediaName} media={this.props.item} />
                </AltContainer>
            );
        }
    },

    renderItemMeta() {
        const item     = this.props.item.toJS();
        const MICode   = item.meta.find( meta => 'MICode' === meta.key );
        const master   = item.files.find( file => 'master' === file.key );
        const duration = master && master.meta && master.meta.find && master.meta.find( meta => 'Duration' === meta.name && !meta.hidden );

        return(
            <div>
                {item.additionalText && <div className="item__additional">{item.additionalText}</div>}
                <div className="item__meta">
                    {MICode && <div className="meta__micode">{MICode.value}</div>}
                    {duration && <div className="meta__duration">{duration.value}</div>}
                </div>
            </div>
        );
    },

    render() {
        const item         = this.props.item.toJS();
        const itemType     = item.type;
        const itemTitle    = ( item.title && item.title.length ) ? item.title : item.name;
        const hideActions  = false === item.showdownload || false;
        const hideCheckbox = hideActions;

        const { hideAssetDescription, mediaBoxFontSize } = flux.getStore('app').getState().config.toJS();

        return (
            <div className={classnames( 'item__info', { 'item__info--has-actions': !hideActions, 'item__info--no-actions': hideActions } )} style={{height: ((hideAssetDescription) ? 'auto' : null), minHeight: ((hideAssetDescription) ? '44px' : null)}}>
                <div className="info__top">
                    {!hideCheckbox && <div className="top__checkbox">
                        <form>
                            <div className="field__checkbox">
                                <input readOnly type="checkbox" id={'item_' + item.id} checked={item._checked} />
                                <label onClick={this.toggleCheck} htmlFor={'item_' + item.id}/>
                            </div>
                        </form>
                    </div>}
                    <h4 className="top__title" title={itemTitle} style={{fontSize: ((mediaBoxFontSize) ? mediaBoxFontSize + 'px' : null), marginTop: ((mediaBoxFontSize && mediaBoxFontSize < 20) ? (20 - mediaBoxFontSize)/2 + 'px' : null)}}>
                        {itemTitle}
                    </h4>
                    {!hideActions && <div className="top__actions">
                        <div onClick={this.generateInstantDownload} className="actions__directdownload">
                            <div className="directdownload__button">
                                <i className="gopro-download" />
                            </div>
                        </div>
                        <div onClick={this.toggleBasket} className="actions__addtobasket">
                            <div className="addtobasket__button">
                                <i className="gopro-plus-small" />
                            </div>
                        </div>
                        {this.renderBasket()}
                    </div>}
                </div>

                {!hideAssetDescription && <div className="item__description">
                    {trunc( item.description, 120 )}
                </div>}
                {hideAssetDescription && <br />}
                {this.renderItemMeta()}
            </div>
        );
    }
});

module.exports = MediaListingItemInfo;



// WEBPACK FOOTER //
// ./app/pages/media/mediaListingItemInfo.jsx